

import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';
import KTFile from "@/components/files/File.vue";
import { errManager } from "@/core/config/Tools";
import MultimediaService from '@/core/services/MultimediaService'
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "tournament-home",
    components: { KTFile },
    setup() {
        const { t } = useI18n();
        const loader = ref(false)
        const route = useRoute();
        const { id } = route.params
        const listDocs = ref<any>([])
        
        const getData = async() => {
            loader.value = true
            await MultimediaService.getData({idevent: id, tabla: 'events'})
            .then((res)=>{
                listDocs.value = res.data
                loader.value = false
            }).catch(({response})=>{
                loader.value = false
                errManager(response)
            })
        }

        onMounted(()=>{
            getData()
        })

        return {
            t,
            loader,
            listDocs,
            getData
        }
    },
})
